// Random German pseudonym generator: Adjektiv + Tier.
// All animals are masculine ("der …") so the adjective gets the strong
// nominative ending "-er" (or just "-r" if the stem already ends in -e).

const ADJECTIVES = [
  'fröhlich',
  'ruhig',
  'klug',
  'schnell',
  'mutig',
  'hungrig',
  'leise',
  'sanft',
  'wild',
  'listig',
  'stark',
  'weise',
  'gelassen',
  'freundlich',
  'neugierig',
  'schlau',
  'fleißig',
  'glücklich',
  'tapfer',
  'stolz',
  'geduldig',
  'wendig',
  'flink',
  'charmant',
  'gewitzt',
  'beherzt',
  'kühn',
  'eifrig',
  'geschickt',
  'pfiffig',
  'munter',
  'verträumt',
  'zufrieden',
  'aufmerksam',
];

const ANIMALS = [
  'Otter',
  'Fuchs',
  'Bär',
  'Dachs',
  'Wolf',
  'Adler',
  'Hase',
  'Igel',
  'Specht',
  'Kater',
  'Falke',
  'Marder',
  'Luchs',
  'Biber',
  'Storch',
  'Kranich',
  'Maulwurf',
  'Habicht',
  'Iltis',
  'Rabe',
  'Sperling',
  'Schwan',
  'Pinguin',
  'Tapir',
  'Reiher',
  'Hirsch',
  'Tiger',
  'Löwe',
  'Panther',
  'Delfin',
  'Wal',
  'Hai',
  'Karpfen',
  'Salamander',
];

function declineMasculine(adj: string): string {
  // "fröhlich" → "fröhlicher"; "leise" → "leiser"; "weise" → "weiser"
  return adj.endsWith('e') ? adj + 'r' : adj + 'er';
}

/** Picks a random adjective + animal combo. Fully grammatically correct. */
export function generatePseudonym(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  return `${declineMasculine(adj)} ${animal}`;
}

/** Generates a UUID v4 for the voter id (client side). */
export function generateVoterId(): string {
  // crypto.randomUUID is widely available in modern browsers.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback (very old browsers): build a uuid from random hex.
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
